import { render } from "./QuestionPanel.vue?vue&type=template&id=6314b792"
import script from "./QuestionPanel.vue?vue&type=script&lang=js"
export * from "./QuestionPanel.vue?vue&type=script&lang=js"

import "./QuestionPanel.vue?vue&type=style&index=0&id=6314b792&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__